<section
  class="widget-tabs max-[429px]:w-[343px] min-[430px]:w-auto tablet:w-auto ultrawide:w-[1152px] tablet:justify-center flex laptop:justify-between laptop:gap-[34px] ultrawide:gap-[202px]"
  role="region"
  aria-label="Booking tabs and external links"
  id="mach-core-widget-tabs-section"
>
  <div
    class="tabs min-w-[405px] laptop:w-[477px] desktop:w-auto"
    [id]="content.tabBookingOptions.id"
    (click)="onSearchButtonClick($event)"
  ></div>
  <div
    class="external-links hidden laptop:flex justify-end items-center laptop:w-[417px]"
    aria-label="External links"
    id="mach-core-widget-external-links"
  >
    <a
      (click)="
        onExternalClick(content.externalLinks.links.deltaAmexCard);
        onLinkClick($event)
      "
      href="javascript:void(0)"
      [attr.data-acdl-action]="
        'widget:' + (content.externalLinks.text.deltaAmexCard | lowercase)
      "
      [attr.data-acdl-name]="
        content.externalLinks.text.deltaAmexCard | lowercase
      "
      [attr.data-acdl-page-section]="
        'header:' +
        bookingTab +
        ':' +
        (content.externalLinks.text.deltaAmexCard | lowercase)
      "
      class="external-links__delta-amex h-min no-underline text-caption-semibold text-inverse flex items-center mr-auto"
      role="button"
      tabindex="0"
      (keydown.enter)="
        onExternalClick(content.externalLinks.links.deltaAmexCard);
        onLinkClick($event)
      "
      (keydown.space)="
        onExternalClick(content.externalLinks.links.deltaAmexCard);
        onLinkClick($event)
      "
      [attr.aria-label]="
        content.externalLinks.text.deltaAmexCard +
        content.externalLinks.accessibility.altText
      "
      id="mach-core-widget-delta-amex-link"
    >
      <svg
        class="external-links__gold-card mr-[4px]"
        width="22"
        height="14"
        viewBox="0 0 28 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.5 0.25H26.5C27.1904 0.25 27.75 0.809644 27.75 1.5V16.5C27.75 17.1904 27.1904 17.75 26.5 17.75H1.5C0.809644 17.75 0.25 17.1904 0.25 16.5V1.5C0.25 0.809644 0.809644 0.25 1.5 0.25Z"
          fill="url(#paint0_linear_12642_232)"
          stroke="#CAB078"
          stroke-width="0.5"
        />
        <path
          opacity="0.3"
          d="M27.8838 0.921875C27.9582 1.09987 28 1.295 28 1.5V16.5C28 17.3284 27.3284 18 26.5 18H1.5L1.39062 17.9941L27.8818 0.920898L27.8838 0.921875Z"
          fill="url(#paint1_linear_12642_232)"
          fill-opacity="0.8"
        />
        <path
          d="M16.3144 18.0155L1.5 18C0.671573 18 0 17.3284 0 16.5V1.5C0 0.671573 0.671573 0 1.5 0L4.59135 0.0131502L16.3144 18.0155Z"
          fill="url(#paint2_linear_12642_232)"
          fill-opacity="0.4"
        />
        <path
          d="M3 6.84962C3 6.40779 3.35817 6.04962 3.8 6.04962H6.2C6.64183 6.04962 7 6.40779 7 6.84962V8.27443C7 8.71626 6.64183 9.07443 6.2 9.07443H3.8C3.35817 9.07443 3 8.71626 3 8.27443V6.84962Z"
          fill="url(#paint3_linear_12642_232)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.2544 14.0476L15.5908 8.90381L21.4224 5.10962L17.4512 14.0476H16.2544ZM11.9302 11.2866L14.439 9.6543L15.2266 14.0476H13.7266L11.9302 11.2866Z"
          fill="url(#paint4_linear_12642_232)"
        />
        <path
          d="M9.35839 5.1218L21.4224 5.10962L15.5908 8.90381L9.35839 5.1218ZM8.0625 5.34153L14.439 9.6543L11.9302 11.2866L8.0625 5.34153Z"
          fill="url(#paint5_linear_12642_232)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_12642_232"
            x1="-4"
            y1="-4.5"
            x2="17.2219"
            y2="20.3102"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0647074" stop-color="#FFEBB7" />
            <stop offset="0.966244" stop-color="#91723A" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_12642_232"
            x1="27.6019"
            y1="6.21869"
            x2="5.11093"
            y2="7.96684"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFEBB7" />
            <stop offset="1" stop-color="#644919" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_12642_232"
            x1="-1.56563"
            y1="16.2683"
            x2="15.5"
            y2="12"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.200522" stop-color="#CAB078" />
            <stop offset="1" stop-color="#644919" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_12642_232"
            x1="2.5"
            y1="5.49994"
            x2="9.9804"
            y2="9.6298"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.144236" stop-color="#CAB078" />
            <stop offset="1" stop-color="#FFEBB7" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_12642_232"
            x1="17.1256"
            y1="12.8312"
            x2="16.2557"
            y2="6.27769"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.07" stop-color="#CAB078" />
            <stop offset="0.81" stop-color="#644919" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_12642_232"
            x1="19.4884"
            y1="2.13738"
            x2="7.67502"
            y2="10.0138"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.662487" stop-color="#FFEBB7" />
            <stop offset="1" stop-color="#CAB078" />
          </linearGradient>
        </defs>
      </svg>

      <span
        class="external-links__text text-inverse mr-[4px] whitespace-nowrap"
      >
        {{ content.externalLinks.text.deltaAmexCard }}
      </span>
      <svg
        class="external-links__arrow"
        width="8"
        height="8"
        viewBox="0 0 8 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_14004_127980)">
          <mask
            id="path-1-outside-1_14004_127980"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="8"
            height="8"
            fill="black"
          >
            <rect fill="white" width="8" height="8" />
            <path
              d="M7 1V5.40039H6.2002V2.32715L1.56543 7.00098L1 6.43066L5.5918 1.7998H2.59961V1H7Z"
            />
          </mask>
          <path
            d="M7 1V5.40039H6.2002V2.32715L1.56543 7.00098L1 6.43066L5.5918 1.7998H2.59961V1H7Z"
            fill="white"
          />
          <path
            d="M7 1H7.1V0.9H7V1ZM7 5.40039V5.50039H7.1V5.40039H7ZM6.2002 5.40039H6.1002V5.50039H6.2002V5.40039ZM6.2002 2.32715H6.3002V2.08429L6.12919 2.25674L6.2002 2.32715ZM1.56543 7.00098L1.49442 7.07138L1.56542 7.143L1.63644 7.07139L1.56543 7.00098ZM1 6.43066L0.92899 6.36025L0.859178 6.43066L0.928986 6.50107L1 6.43066ZM5.5918 1.7998L5.66281 1.87022L5.83178 1.6998H5.5918V1.7998ZM2.59961 1.7998H2.49961V1.8998H2.59961V1.7998ZM2.59961 1V0.9H2.49961V1H2.59961ZM7 1H6.9V5.40039H7H7.1V1H7ZM7 5.40039V5.30039H6.2002V5.40039V5.50039H7V5.40039ZM6.2002 5.40039H6.3002V2.32715H6.2002H6.1002V5.40039H6.2002ZM6.2002 2.32715L6.12919 2.25674L1.49442 6.93056L1.56543 7.00098L1.63644 7.07139L6.2712 2.39756L6.2002 2.32715ZM1.56543 7.00098L1.63644 6.93057L1.07101 6.36026L1 6.43066L0.928986 6.50107L1.49442 7.07138L1.56543 7.00098ZM1 6.43066L1.07101 6.50107L5.66281 1.87022L5.5918 1.7998L5.52079 1.72939L0.92899 6.36025L1 6.43066ZM5.5918 1.7998V1.6998H2.59961V1.7998V1.8998H5.5918V1.7998ZM2.59961 1.7998H2.69961V1H2.59961H2.49961V1.7998H2.59961ZM2.59961 1V1.1H7V1V0.9H2.59961V1Z"
            fill="white"
            mask="url(#path-1-outside-1_14004_127980)"
          />
        </g>
        <defs>
          <clipPath id="clip0_14004_127980">
            <rect width="8" height="8" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </a>
    <a
      (click)="onLinkClick($event)"
      [href]="content.externalLinks.links.giftCard"
      [attr.data-acdl-action]="
        'widget:' + (content.externalLinks.text.giftCards | lowercase)
      "
      [attr.data-acdl-name]="content.externalLinks.text.giftCards | lowercase"
      [attr.data-acdl-page-section]="
        'header:' +
        bookingTab +
        ':' +
        (content.externalLinks.text.giftCards | lowercase)
      "
      class="external-links__delta-gift-card text-caption-semibold text-inverse no-underline flex items-center"
      role="button"
      tabindex="0"
      (keydown.enter)="onLinkClick($event)"
      (keydown.space)="onLinkClick($event)"
      [attr.aria-label]="
        content.externalLinks.text.giftCards +
        content.externalLinks.accessibility.altText
      "
      id="mach-core-widget-gift-card-link"
    >
      <svg
        class="external-links__gift-card mr-[4px]"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <path
          d="M1.2002 5.09985H22.7998C23.2969 5.09985 23.7002 5.50319 23.7002 6.00024V18.0002C23.7001 18.4972 23.2968 18.8997 22.7998 18.8997H1.2002C0.703204 18.8997 0.29991 18.4972 0.299805 18.0002V6.00024C0.299805 5.50319 0.703139 5.09985 1.2002 5.09985Z"
          fill="white"
          stroke="#80859C"
          stroke-width="0.6"
        />
        <path
          d="M19.5728 9.29507L19.1421 6.23274L20.8041 5.18237L21.3306 5.18611L19.5728 9.29507Z"
          fill="#8B2332"
        />
        <path
          d="M19.2698 9.75393L17.6113 7.22048L18.6593 6.54541L19.2698 9.75393Z"
          fill="#8B2332"
        />
        <path
          d="M17.611 7.24951L16.2739 5.17749L16.6284 5.17998L18.659 6.57437L17.611 7.24951Z"
          fill="#CF0A2C"
        />
        <path
          d="M17.3746 5.18928L20.7892 5.17998L19.1424 6.26301L17.3746 5.18928Z"
          fill="#CF0A2C"
        />
        <path
          d="M1.2002 5.09985H22.7998C23.2969 5.09985 23.7002 5.50319 23.7002 6.00024V18.0002C23.7001 18.4972 23.2968 18.8997 22.7998 18.8997H1.2002C0.703204 18.8997 0.29991 18.4972 0.299805 18.0002V6.00024C0.299805 5.50319 0.703139 5.09985 1.2002 5.09985Z"
          stroke="#AAADBD"
          stroke-width="0.6"
        />
        <rect
          x="3.8877"
          y="11.2009"
          width="14.688"
          height="2.4"
          fill="url(#pattern0_14004_127986)"
        />
        <defs>
          <pattern
            id="pattern0_14004_127986"
            patternContentUnits="objectBoundingBox"
            width="1"
            height="1"
          >
            <use
              xlink:href="#image0_14004_127986"
              transform="scale(0.00259067 0.0166667)"
            />
          </pattern>
          <image
            id="image0_14004_127986"
            width="386"
            height="60"
            preserveAspectRatio="none"
            xlink:href="data:image/png;base64,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"
          />
        </defs>
      </svg>

      <span class="external-links__text text-inverse whitespace-nowrap">
        {{ content.externalLinks.text.giftCards }}
      </span>
    </a>
    <a
      [href]="content.externalLinks.links.updateBagTravelFees"
      (click)="onLinkClick($event)"
      data-acdl-action="widget:updated bags & fees"
      data-acdl-name="updated bags & fees"
      data-acdl-page-section="header:book:updated bags & fees"
      class="external-links__update-bag-travel text-caption-semibold text-inverse no-underline flex items-center ml-auto"
      role="button"
      tabindex="0"
      (keydown.enter)="onLinkClick($event)"
      (keydown.space)="onLinkClick($event)"
      [attr.aria-label]="
        content.externalLinks.text.updateBagTravelFees +
        content.externalLinks.accessibility.altText
      "
      id="mach-core-widget-update-bag-travel-link"
    >
      <span class="external-links__text text-inverse whitespace-nowrap">
        {{ content.externalLinks.text.updateBagTravelFees }}
      </span>
    </a>
  </div>
</section>
